import { Page } from '@/core/architecture'

import { ConsoleDmRoomDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDmRoomDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleDmRoomDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleDmRoomDetailTemplate state={state} {...actions} />
}
